import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { environment } from '@env/environment';
import { LogLevel, OidcSecurityService, OpenIdConfiguration, provideAuth } from 'angular-auth-oidc-client';
import { checkAuthOnStart } from '@services/tab-aware-auth';

export const keycloakProvider = (log: boolean = true): EnvironmentProviders => {
    const config: OpenIdConfiguration = {
        authority: environment.keycloak.authority,
        // Адрес возврата с Keycloak — корень приложения: глубокие адреса в redirect_uri Keycloak
        // не принимает. Раздел, открытый до входа, хранится в sessionStorage (AuthService.loginSso)
        // и восстанавливается в authGuard.
        redirectUrl: window.location.origin,
        // Тот же корень: после end-session вкладка возвращается в приложение и рассылает
        // остальным сигнал выхода (AuthService.completeLogout). Корень SPA должен быть в
        // post.logout.redirect.uris клиента в Keycloak.
        postLogoutRedirectUri: window.location.origin,
        clientId: environment.keycloak.clientId,
        scope: environment.keycloak.scope,
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        // Обновлять токен заранее, а не в момент истечения: иначе запрос, ушедший на минуту
        // позже expiry, получал бы 401 (типично для фоновой вкладки, где таймеры идут медленно).
        renewTimeBeforeTokenExpiresInSeconds: 30,
        logLevel: LogLevel.Warn,
        // forbiddenRoute и unauthorizedRoute не задаём: таких маршрутов в приложении нет,
        // а unauthorizedRoute попал бы под authGuard — при неудачном разборе ответа Keycloak
        // гард ушёл бы в authorize по кругу.
    };
    log && console.log(config);
    return makeEnvironmentProviders([
        provideAuth({ config }),
        // Вход проверяется до старта приложения, как с withAppInitializerAuthCheck(); при истёкшем
        // access-токене — обновление по refresh-токену, без перехода на Keycloak (#29300).
        provideAppInitializer(() => checkAuthOnStart(inject(OidcSecurityService))),
    ]);
};
